exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".oneday{background-color:rgba(233,232,248,.5);width:354px;min-height:80px;margin:10px 5px;border-left:4px solid;padding:1px 5px;line-height:1.2}.oneday p{font-size:.8rem;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1ebba080","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Lunch.vue
// module id = 675
// module chunks = 0